module.exports = __webpack_public_path__ + "img/img_vision.f1eb0e9c.webp";